import envModules from "./env/modules";

import textMeasureModules from "./textMeasure/modules";

import layerHandlerModules from "./layerHandler/modules";

export default function load(container) {
    envModules({
        bind: container.bind
    }), textMeasureModules({
        bind: container.bind
    }), layerHandlerModules({
        bind: container.bind
    });
}
//# sourceMappingURL=modules.js.map
